const CONTACT_PHONE = "+55 (47) 99230-1776";
const CONTACT_PHONE_LINK = "5547992301776";
const WHATSAPP_BASE =
  "https://wa.me/5547992301776?text=Ol%C3%A1,%20Ana%20Carolina.%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20seu%20trabalho.";
const WHATSAPP_SCHEDULE =
  "https://wa.me/5547992301776?text=Ol%C3%A1,%20Ana%20Carolina.%20Gostaria%20de%20agendar%20um%20atendimento.";

export const APP_STRINGS = {
  brand: {
    mobile: "ANA CAROLINA LUCENA",
    desktop: "ANA CAROLINA LUCENA | ADVOCACIA",
    fullName: "Ana Carolina Lucena",
  },
  links: {
    instagram: "https://www.instagram.com/draanalucenaadvocacia",
    whatsapp: WHATSAPP_BASE,
    whatsappSchedule: WHATSAPP_SCHEDULE,
    whatsappShort: `https://wa.me/${CONTACT_PHONE_LINK}`,
  },
  navigation: {
    items: [
      { id: "home", label: "Início" },
      { id: "apresentation", label: "Escritório" },
      { id: "skills", label: "Atuação" },
      { id: "partners", label: "Diferenciais" },
      { id: "location", label: "Localização" },
      { id: "contact", label: "Contato" },
    ],
    instagramTooltip: "Seguir no Instagram",
    whatsappTooltip: "Entrar em contato no WhatsApp",
    cta: "Agendar conversa",
  },
  hero: {
    eyebrow: "Advocacia e assessoria jurídica boutique",
    title: "Estratégia jurídica com imagem, presença e sofisticação.",
    subtitle:
      "Um escritório pensado para quem busca firmeza técnica, atendimento humano e uma experiência mais refinada em direito civil, família, sucessões e empresarial.",
    primaryCta: "Agendar conversa estratégica",
    secondaryCta: "Falar no WhatsApp",
    metrics: [
      {
        value: "+360",
        label: "processos conduzidos com atuação consultiva e contenciosa.",
      },
      {
        value: "80+",
        label: "clientes ativos acompanhados com atenção próxima e estratégica.",
      },
      {
        value: "14+",
        label: "anos de experiência em demandas patrimoniais, empresariais e de família.",
      },
    ],
    panelTag: "Assinatura do escritório",
    panelTitle: "Defesa moderna e profundamente preparada.",
    panelText:
      "A proposta desta landing é transmitir exatamente o que a marca pede: autoridade serena, estética sofisticada e sensação de acolhimento premium para quem precisa de orientação segura.",
    panelItems: [
      {
        title: "Atendimento estratégico",
        text: "Escuta qualificada, leitura técnica do cenário e orientação clara desde o primeiro contato.",
      },
      {
        title: "Proteção patrimonial",
        text: "Estruturas jurídicas, contratos e prevenção de litígios com foco em segurança e continuidade.",
      },
      {
        title: "Presença firme",
        text: "Uma advocacia contemporânea, feminina e autoritativa, sem excessos nem linguagem genérica.",
      },
    ],
  },
  presentation: {
    label: "Escritório moderno",
    title: "Uma advocacia feminina, sofisticada e estrategicamente preparada.",
    lead:
      "Dra. Ana Carolina Lucena construiu uma atuação marcada por presença, organização técnica e leitura cuidadosa de cada caso. A proposta do escritório é unir firmeza jurídica, atendimento refinado e soluções que transmitam segurança desde o primeiro contato.",
    primaryCta: "Agendar atendimento",
    secondaryCta: "Ver áreas de atuação",
    stats: [
      {
        value: "+360",
        label: "processos conduzidos ao longo da trajetória profissional.",
      },
      {
        value: "50+",
        label: "clientes ativos acompanhados com proximidade.",
      },
      {
        value: "Regional",
        label: "atuação em Santa Catarina e Paraná.",
      },
    ],
    floatingTitle: "Assinatura profissional",
    floatingText:
      "Atendimento com discrição, clareza estratégica e uma presença visual compatível com o nível de confiança que a área jurídica exige.",
    credentialsTitle: "Credenciais e formação",
    credentialsText:
      "Especialização contínua em áreas que exigem profundidade técnica e sensibilidade estratégica, com atuação consultiva e contenciosa.",
    credentialsItems: [
      "Direito Civil e Processo Civil",
      "Direito de Família",
      "Direito Empresarial e Contratos",
      "Direito Administrativo",
    ],
    specialtiesTitle: "Frentes centrais de atuação",
    specialtiesText:
      "Uma operação jurídica pensada para preservar patrimônio, orientar decisões relevantes e reduzir fricções desnecessárias ao longo do caminho.",
    specialtiesItems: [
      "Direito Civil",
      "Família e Sucessões",
      "Empresarial",
      "Contratos",
      "Prevenção de litígios",
      "Proteção patrimonial",
    ],
    videoBadge: "Vídeo institucional",
    videoTitle: "Presença, posicionamento e atendimento em movimento.",
    videoText:
      "O vídeo institucional reforça a proposta desta marca: uma advocacia contemporânea, elegante e segura, com atendimento próximo e linguagem visual mais refinada.",
    videoCaption: "Apresentação institucional do escritório.",
    portraitAlt: "Retrato profissional da Dra. Ana Carolina Lucena",
  },
  skills: {
    eyebrow: "Áreas de atuação",
    title:
      "O escritório atua onde a decisão jurídica precisa de refinamento, firmeza e direção.",
    subtitle:
      "A proposta aqui não é oferecer volume, e sim presença estratégica. Cada frente de atuação foi organizada para comunicar segurança técnica, sofisticação no atendimento e consistência na execução.",
    areas: [
      {
        title: "Direito Civil",
        text:
          "Atuação em contratos, responsabilidade civil, obrigações, litígios patrimoniais e estratégias preventivas para reduzir exposição e insegurança.",
        bullets: [
          "Elaboração e revisão contratual com foco em clareza e proteção.",
          "Condução contenciosa em disputas patrimoniais e indenizatórias.",
          "Organização documental para diminuir o risco de conflito futuro.",
        ],
      },
      {
        title: "Família e Sucessões",
        text:
          "Casos que exigem técnica e sensibilidade, com condução segura de separações, guarda, alimentos, inventários e reorganização patrimonial familiar.",
        bullets: [
          "Atuação humanizada com firmeza jurídica.",
          "Acordos estratégicos sempre que forem realmente vantajosos.",
          "Proteção patrimonial e sucessória com visão de longo prazo.",
        ],
      },
      {
        title: "Empresarial",
        text:
          "Suporte jurídico para empresas que precisam estruturar contratos, reduzir passivos, padronizar processos e tomar decisões com mais segurança.",
        bullets: [
          "Diagnóstico jurídico da operação.",
          "Acompanhamento consultivo e prevenção de litígios.",
          "Organização de rotinas e instrumentos jurídicos essenciais.",
        ],
      },
    ],
    strategyTitle: "A estética foi pensada para refletir o método.",
    strategyText:
      "Um escritório moderno: organização, presença, seriedade e atenção ao detalhe. Essa linguagem visual apoia o posicionamento de uma advocacia mais premium e contemporânea.",
    methods: [
      {
        title: "Leitura do cenário",
        text: "Antes de agir, o escritório entende contexto, risco, urgência e impacto patrimonial ou relacional de cada decisão.",
      },
      {
        title: "Estratégia clara",
        text: "O cliente sabe onde está, quais caminhos existem e qual racional sustenta a recomendação jurídica escolhida.",
      },
      {
        title: "Execução organizada",
        text: "Peças, documentos, prazos e comunicação seguem uma apresentação mais madura, confiável e consistente.",
      },
    ],
    cta: "Falar sobre meu caso",
  },
  partners: {
    eyebrow: "Diferenciais",
    title:
      "O digital do escritório também precisa transmitir confiança.",
    subtitle:
      "Para um escritório de advocacia, o design não é detalhe. Ele influencia a percepção de autoridade, cuidado, nível de profissionalismo e expectativa de atendimento.",
    cards: [
      {
        title: "Segurança com clareza",
        text: "O cliente entende o cenário, o risco e a estratégia. Isso aumenta a confiança e reduz a sensação de incerteza.",
      },
      {
        title: "Condução organizada",
        text: "A experiência digital e o atendimento refletem método, prazo, presença e atenção ao detalhe desde o primeiro contato.",
      },
      {
        title: "Imagem compatível com o posicionamento",
        text: "O escritório passa a comunicar elegância, contemporaneidade e autoridade sem parecer impessoal ou genérico.",
      },
    ],
    quote:
      "Elegância aqui não é ornamento. É uma forma de comunicar ordem, serenidade, preparo e confiança.",
    quoteText:
      "Quando a apresentação visual do escritório acompanha a qualidade técnica, a marca se posiciona de maneira mais forte e memorável. Esse é o tipo de percepção que queremos consolidar ao longo da nova landing page.",
    quoteBadge: "Advocacia moderna com presença feminina e premium",
    cta: "Solicitar atendimento",
  },
  location: {
    badge: "Localização",
    title: "Um espaço preparado para receber com discrição e presença.",
    text:
      "O atendimento presencial acompanha a mesma proposta da marca: ambiente acolhedor e estrutura adequada.",
    detailTitle: "Joinville, Santa Catarina ",
    detailText:
      "Atendimento presencial com estrutura profissional e possibilidade de contato inicial pelo WhatsApp para agilizar orientação, triagem e agendamento.",
    primaryCta: "Agendar atendimento",
    secondaryCta: "WhatsApp",
    mapTitle: "Mapa do escritório",
  },
  contact: {
    phone: CONTACT_PHONE,
    badge: "Contato",
    title: "Vamos conversar com calma, clareza e direção.",
    text:
      "Este formulário foi pensado para um primeiro contato mais qualificado. Se preferir, o retorno pode ser feito por e-mail, WhatsApp ou telefone, conforme o seu contexto.",
    points: [
      {
        title: "WhatsApp e telefone",
        value: CONTACT_PHONE,
      },
      {
        title: "Atendimento profissional",
        value:
          "Resposta com direcionamento inicial e encaminhamento para a forma de atendimento mais adequada.",
      },
      {
        title: "Agendamentos",
        value:
          "Conversas estratégicas podem ser iniciadas pelo formulário e continuadas em reunião ou atendimento presencial.",
      },
    ],
    formTitle: "Inicie seu atendimento.",
    formText:
      "Selecione a área jurídica e compartilhe o contexto inicial para que o retorno seja mais claro, objetivo e assertivo.",
    fields: {
      name: "Nome completo *",
      nameHelper: "Ex.: Ana Carolina da Silva.",
      email: "E-mail *",
      emailHelper: "Usaremos para retornar seu contato.",
      phone: "Telefone *",
      phoneHelper: "Preferencialmente com WhatsApp.",
      company: "Empresa (opcional)",
      companyHelper: "Se houver vínculo empresarial.",
      legalArea: "Área jurídica *",
      legalAreaHelper: "Selecione a frente principal do seu atendimento.",
      subject: "Assunto *",
      subjectHelper: "Selecione o tema principal.",
      motive: "Motivo do contato *",
      motiveHelper: "Ajuda a direcionar o retorno.",
      preferredChannel: "Canal preferido para retorno",
      message: "Mensagem *",
      messageHelper:
        "Inclua informações relevantes para agilizar a orientação inicial.",
      lgpdLabelStart:
        "Li e concordo com o tratamento dos meus dados conforme a",
      lgpdPolicy: "Política de Privacidade (LGPD)",
      newsletter:
        "Desejo receber materiais e novidades por e-mail (opcional).",
      subtle:
        "Seus dados são usados apenas para retorno do contato. Você pode solicitar exclusão a qualquer momento.",
      submit: "Enviar mensagem",
      clear: "Limpar",
      honeypot: "Cargo",
    },
    legalAreas: [
      { value: "familia-sucessoes", label: "Família e Sucessões" },
      { value: "direito-civil", label: "Direito Civil" },
      { value: "empresarial", label: "Empresarial" },
      { value: "contratos", label: "Contratos" },
      { value: "inventario", label: "Inventário" },
      { value: "divorcio", label: "Divórcio" },
      { value: "guarda", label: "Guarda" },
      { value: "cobranca", label: "Cobrança" },
      { value: "analise-contratual", label: "Análise Contratual" },
    ],
    subjects: [
      { value: "proposta", label: "Solicitar proposta" },
      { value: "duvidas", label: "Dúvidas gerais" },
      { value: "reuniao", label: "Agendar conversa" },
      { value: "juridico", label: "Assunto jurídico específico" },
    ],
    motives: [
      { value: "civil", label: "Atendimento em Direito Civil" },
      { value: "familia", label: "Atendimento em Família e Sucessões" },
      { value: "empresarial", label: "Atendimento Empresarial" },
      { value: "outros", label: "Outros" },
    ],
    preferredChannels: [
      { value: "email", label: "E-mail" },
      { value: "whatsapp", label: "WhatsApp" },
      { value: "telefone", label: "Telefone" },
    ],
    validation: {
      name: "Informe nome e sobrenome.",
      email: "Informe um e-mail válido.",
      phone: "Informe um telefone válido (DDD + número).",
      legalArea: "Selecione a área jurídica.",
      subject: "Selecione um assunto.",
      motive: "Selecione o motivo do contato.",
      messageMin: (min) =>
        `Descreva com um pouco mais de detalhes (mín. ${min} caracteres).`,
      messageMax: (max) =>
        `Sua mensagem está muito longa (máx. ${max} caracteres).`,
      lgpd: "É necessário concordar com o tratamento dos dados (LGPD).",
    },
    feedback: {
      review: "Revise os campos destacados.",
      success: "Mensagem enviada com sucesso.",
      error:
        "Não foi possível enviar agora. Tente novamente em instantes ou use o WhatsApp.",
      companyFallback: "(não informado)",
      yes: "Sim",
      no: "Não",
      submitAria: "Enviar mensagem",
    },
  },
  footer: {
    eyebrow: "Escritório de advocacia contemporâneo",
    title: "Ana Carolina Lucena",
    text: "Atendimento jurídico com presença e estratégia.",
    rights: "Todos os direitos reservados.",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
  },
  floatingWhatsapp: {
    ariaLabel: "Falar no WhatsApp",
  },
};
